import './ToggleButton.scss'

interface ToggleOption {
  label: string
  value: string
}

interface ToggleButtonProps {
  options: [ToggleOption, ToggleOption]
  value: string
  onChange: (value: string) => void
  size?: 'sm' | 'md'
}

export const ToggleButton = ({
  options,
  value,
  onChange,
  size = 'sm',
}: ToggleButtonProps) => {
  return (
    <div className={`toggle-button toggle-button--${size}`}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`toggle-button__option ${
            value === option.value ? 'toggle-button__option--active' : ''
          }`}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}
